import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import * as $ from "jquery";
import { CAPService } from "../../core/services/cap-service";
import { Router, ActivatedRoute } from "@angular/router";
import { PagerService } from "../../core/services/pager.service";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
//import { Script } from 'vm';
import { map, debounceTime, filter, tap, switchMap } from "rxjs/operators";
import { DatePipe, Location } from "@angular/common";

@Component({
  selector: "app-short-code",
  templateUrl: "./short-code.component.html",
  styleUrls: ["./short-code.component.css"],
})
export class ShortCodeComponent implements OnInit {
  public LoginEnterpriseID = "";
  public Role = "";
  ShortCodes: any[];
  Countries: any[];
  Facilities: any[];
  ShortCodeStatus: any[];
  successfulData;
  DeviceTypeList;
  ShortCodeDetails;
  dataLoader: boolean;
  pager: any = {};
  private allItems: any[];
  pagedItems: any[];
  Device;
  public country = "";
  public Type = "";
  public Country = "";
  public DeviceType;
  public _Country;
  FacilityName;
  FacilityList: any[];
  MultiFacilityList: any[];
  public dropDownSettings: IDropdownSettings;
  addModifyHostNamesForm: FormGroup;
  theFile: any;
  MultiSelectFacilityCisco: any[];
  selectedFacility: any;
  public Id: number;
  public count: number;
  public CategoryName: string;
  public Facility: any;
  public ShortCode: any[];
  public PhoneNumber: string;
  public WBSE: string;
  public selected: string;
  selectedshortcode: any[];
  public Delete: any[] = [];

  shortcodeChecked:boolean=false;
  shortcode: any;
  strType: any;
  file: any;
  selectedAll;
  i = 0;
  Count = 0;
  maincount = 0;
  mainCountSingle = 0;
  CountAll = 1;
  griddata: any;

  constructor(
    private router: Router,
    private capservice: CAPService,
    private fb: FormBuilder,
    private _avRoute: ActivatedRoute,
    private pagerService: PagerService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    this.LoginEnterpriseID = capservice.enterpriseid;
    this.Role = capservice.Role;
    this.Country = capservice.country;
    this._Country = capservice.country;

    if (this.Role == "Regional Voice Admin") {
      this.country = this.Country;
      this.Type = "Regional";
    } else if (this.Role == undefined) {
    } else {
      this.country = "N";
      this.Type = "N";
    }
  }

  ngOnInit(): void {
    this.dataLoader = true;
    this.selectedFacility = [];

    this.dropDownSettings = {
      itemsShowLimit: 1,
      idField: "label_id",
      allowSearchFilter: true,
      textField: "label",
      selectAllText: "Check All",
      unSelectAllText: "UnCheck All",
      maxHeight: 100,
      searchPlaceholderText: "Search",
      clearSearchFilter: true,
      noDataAvailablePlaceholderText: "No data available",
    };

    this.DeviceTypeList = [{ name: "Cisco" }];
    this.successfulData = {
      Id: "",
      ID1: "",
      CategoryName: "",
      Facility: "",
      ShortCode: "",
      PhoneNumber: "",
      WBS_Element: "",
      strType: "",
      Status: "",
      selected: "",
    };
    this.ShortCodeDetails = {
      CategoryName: "",
      Facility: "",
      ShortCode: "",
      PhoneNumber: "",
      WBS_Element: "",
      strType: "",
    };
    this.addModifyHostNamesForm = this.fb.group({
      CategoryName: ["", Validators.required],
      facility: ["", Validators.required],
      ShortCode: ["", Validators.required],
      PhoneNumber: ["", Validators.required],
      WBSE: ["", Validators.required],
      domain: ["", Validators.required],
      device: ["", Validators.required],
      hostName: ["", Validators.required],
      inputFile: "",
    });

    this.ShortCodeStatus = [
      {
        name: "Active",
      },
      {
        name: "InActive",
      },
    ];
    this.GetShortCodeDropDown();
    this.GetFacilityListDropDown();
    this.AudiLogin();
    this.GetFacility();
  }

  AudiLogin() {
    this.capservice
      .AudiLogin("ShortCode", this.LoginEnterpriseID)
      .subscribe((data) => {});
  }
  GetShortCodeDropDown() {
    this.capservice
      .GetVoiceAdminDetails(this.Device, "ShortCodeDropdown", this.country)
      .subscribe((data) => {
        this.ShortCodes = data;
        this.dataLoader = false;
      });
  }

  GetFacilityListDropDown() {
    this.capservice.FacilityList("India").subscribe((data) => {
      this.MultiFacilityList = data;
      const MultiCountryTypeObj = { MultiCountryTypeArray: [] };
      for (let i = 0; i < data.length; i++) {
        const CountryType = { label_id: i, label: data[i].Description };
        MultiCountryTypeObj.MultiCountryTypeArray.push(CountryType);
      }
      this.MultiFacilityList = MultiCountryTypeObj.MultiCountryTypeArray;
    });
  }

  GetFacility() {
    const country = "India";
    this.capservice.FacilityList(country).subscribe((data) => {
      this.Facilities = data;
      this.dataLoader = false;
    });
  }
  validateNumber(e: any) {
    const input = String.fromCharCode(e.charCode);
    const reg = /^[\d #!+-]+$/; // /^[\d +-]+$/;

    if (!reg.test(input)) {
      e.preventDefault();
    }
  }
  validateNo(e: any) {
    const input = String.fromCharCode(e.charCode);
    const reg = /^[0-9]*$/;

    if (!reg.test(input)) {
      e.preventDefault();
    }
  }
  //checkall chk
  checkAll(isChecked) {
    this.selectedAll = isChecked;
    this.successfulData.shortcodes.forEach((shortcode) => {
      shortcode.checked = this.selectedAll;
    });
  }
  DeviceTypeEvent(event: any) {
    this.Device = event.target.value;
    if (this.Device == "Cisco") {
      $("#divShortcodeDetailsCommon").css("display", "block");
      $("#divShortcodeSubmit").css("display", "block");
      $("#divProjectDetailsCommonupload").css("display", "block");
      $("#divShortcodeDetails").css("display", "block");
      $("#AlertForAccess").css("display", "none");

      this.LoadData();
    }
  }

  LoadData() {
    this.capservice.GatewayList(null, "ShortCode", null).subscribe((data) => {
      this.dataLoader = true;
      if (data.length >= 0) {
        this.successfulData = { shortcodes: data, selected: {} };

        this.allItems = data;

        this.setPage(1);
        this.GetShortCodeDropDown();
        this.dataLoader = false;
      }
    });
  }

  EditShortCode(shortcode) {
    this.successfulData.selected = Object.assign({}, shortcode);
  }
  DeleteShortCode(shortcode) {
    this.capservice
      .DeleteVoiceAdminDetails(shortcode.Id, "ShortCode", null, null)
      .subscribe((data) => {
        if (data.length > 0) {
          alert("Deleted Successfully");
          this.clear();
        } else {
          alert(data);
          this.clear();
        }
      });
  }
  deleteshortcodeSelected() {
    let shortcodeId = "";
    for (let i = 0; i < this.successfulData.shortcodes.length; i++) {
      if (this.successfulData.shortcodes[i].checked) {
        shortcodeId = shortcodeId + "," + this.successfulData.shortcodes[i].Id;
      }
    }
    if (shortcodeId != "" && shortcodeId != null) {
      this.capservice
        .DeleteVoiceAdminDetails(shortcodeId, "ShortCode", null, null)
        .subscribe((data) => {
          alert("Deleted Successfully");
          this.clear();
        });
    } else {
      alert("Please select the checkbox of the record(s) to be deleted");
    }
  }
  ShortCodeUpdate() {
    let message = "";

    if (this.successfulData.selected.CategoryName == "") {
      message = message + "\n" + "Please Enter Category Name";
    }
    if (this.successfulData.selected.Facility == "") {
      message = message + "\n" + "Please Select Facility";
    }
    if (this.successfulData.selected.ShortCode == "") {
      message = message + "\n" + "Please Enter Short Code";
    }
    if (this.successfulData.selected.PhoneNumber == "") {
      message = message + "\n" + "Please Enter Phone Number";
    }
    if (this.successfulData.selected.WBS_Element == "") {
      message = message + "\n" + "Please Enter WBSE";
    }

    if (message != "") {
      alert(message);
    } else {
      this.successfulData.selected.ID1 =
        this.successfulData.selected.Id.toString();
      this.successfulData.selected.Id = this.successfulData.selected.Id;
      this.successfulData.selected.ShortCode =
        this.successfulData.selected.ShortCode.toString();
      this.successfulData.selected.strType = "ShortCode";

      this.capservice
        .UpdateVoiceAdminDetails(this.successfulData.selected)
        .subscribe((data) => {
          if (data.toString() == "Please Enter Valid WBS") {
            alert(data);
          } else if (data.toString() == "Data already exists") {
            alert(
              "Short Code: '" +
                this.successfulData.selected.ShortCode +
                "' Already Exists"
            );
          } else {
            alert(data);
            this.clear();
          }
        });
    }
  }
  ShortCodeAdd() {
    debugger;
    let message = "";

    if (this.ShortCodeDetails.CategoryName == "") {
      message = message + "\n" + "Please Enter Category Name";
    }
    if (this.ShortCodeDetails.Facility == "") {
      message = message + "\n" + "Please Select Facility";
    }
    if (this.ShortCodeDetails.ShortCode == "") {
      message = message + "\n" + "Please Enter Short Code";
    }
    if (this.ShortCodeDetails.PhoneNumber == "") {
      message = message + "\n" + "Please Enter Phone Number";
    }
    if (this.ShortCodeDetails.WBS_Element == "") {
      message = message + "\n" + "Please Enter WBSE";
    }

    if (message != "") {
      alert(message);
    } else {
      this.ShortCodeDetails.strType = "ShortCode";

      this.capservice
        .InsertVoiceAdminDetails(this.ShortCodeDetails)
        .subscribe((data) => {
          if (data.toString() == "Success") {
            alert("Inserted Successfully");
            this.clear();
          } else if (data.toString() == "Please Enter Valid WBS") {
            alert(data);
          } else if (data.toString() == "ShortCode Already Exists") {
            alert(
              "Short Code: '" +
                this.ShortCodeDetails.ShortCode +
                "' Already Exists"
            );
          } else {
            alert(data);
            this.clear();
          }
        });
    }
  }

  ShowData() {
    debugger;
    const Country = "";
    if (
      $("#txtShortCode").val() == "" &&
      $("#drpstatus").val() == "" &&
      this.selectedFacility.length == 0
    ) {
      //$('#divShortcodeDetailsCommon').css("display", 'none');
      alert("Please select value to search");
    } else {
      let Facility = "";
      let City = "";
      if (this.selectedFacility.length == 0) {
        Facility = null;
      } else {
        for (let i = 0; i < this.selectedFacility.length; i++) {
          Facility = Facility + "," + this.selectedFacility[i].label;
        }
        City = Facility.slice(1, Facility.length);
      }
      const Name =
        $("#txtShortCode").val() == "" ? null : $("#txtShortCode").val();
      const Status = $("#drpstatus").val() == "" ? null : $("#drpstatus").val();
      this.capservice
        .SearchDetails(Name, Status, City, null, "ShortCode")
        .subscribe((data) => {
          if (data.length > 0) {
            this.successfulData = { shortcodes: data, selected: {} };
            this.allItems = data;
            // initialize to page 1
            this.setPage(1);
            $("#divShortcodeDetails").css("display", "block");
          } else {
            alert("No Records Found");
            $("#divShortcodeDetails").css("display", "none");
          }
        });
    }
  }

  onFileSelected(event) {
    this.file = event.target.files[0];
  }
  addDetails() {
    this.dataLoader = true;
    const orgfile = this.addModifyHostNamesForm.controls.inputFile.value;
    const ext = orgfile.split(".").pop().toLowerCase();

    if (orgfile == "") {
      alert("Please Upload The Template");
      this.dataLoader = false;
      return;
    }
    if (ext != "xls" && ext != "xlsx") {
      alert("Please upload bulk template in correct format");
      $("#fileControl").val("");
      this.dataLoader = false;
    } else {
      const str = "ShortCode";
      const formData = new FormData();
      formData.append("file", this.theFile);
      this.capservice.BulkUpload(str, formData).subscribe((data) => {
        this.addModifyHostNamesForm.controls.inputFile.setValue("");
        alert(data);
        this.LoadData();
        this.dataLoader = false;
      });
    }
  }
  DownloadPoCreateTemplate() {
    const str = "ShortCode";
    this.dataLoader = true;

    this.capservice.DownloadBulkTemplate(str).subscribe(
      (resultBlob: Blob) => {
        if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
          // for IE
          (window.navigator as any).msSaveOrOpenBlob(
            resultBlob,
            "ShortCodeBulkTemplate.xlsx"
          );
          this.dataLoader = false;
        } else {
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(resultBlob);
          link.download = "ShortCodeBulkTemplate.xlsx";
          link.click();
          this.dataLoader = false;
        }
      },
      function (x) {
        console.log(x);
        alert("Acknowledgement failed");
        this.dataLoader = false;
      }
    );

    this.dataLoader = false;
  }

  setFile(event) {
    this.theFile = event.target.files[0];
  }

  clear() {
    $("#drpstatus").val("");
    this.selectedFacility = [];

    this.ShortCodeDetails.CategoryName = "";
    this.ShortCodeDetails.Facility = "";
    this.ShortCodeDetails.ShortCode = "";
    this.ShortCodeDetails.PhoneNumber = "";
    this.ShortCodeDetails.WBS_Element = "";
    this.LoadData();
    this.dataLoader = false;
    $("#divShortcodeDetails").css("display", "block");
    this.selectedAll = false;
  }
  ExportToBulkExcel() {
    const Country = "";
    let City = "";
    const ReportName = "ShortCode.xlsx";

    const Name =
      $("#txtShortCode").val() == "" ? null : $("#txtShortCode").val();
    const Status = $("#drpstatus").val() == "" ? null : $("#drpstatus").val();
    let Facility = "";
    if (this.selectedFacility.length == 0) {
      Facility = null;
    } else {
      for (let i = 0; i < this.selectedFacility.length; i++) {
        Facility = Facility + "," + this.selectedFacility[i].label;
      }
      City = Facility.slice(1, Facility.length);
    }
    // Load GridData
    //this.capservice.SearchDetails(Name, null, 'N', null, "ShortCode")
    this.capservice
      .SearchDetailsTelcoBulkDownload(
        Name,
        Status,
        City,
        null,
        "ShortCode",
        null
      )
      .subscribe(
        (data: Blob) => {
          this.dataLoader = true;
          if (data.size > 0) {
            if (
              window.navigator &&
              (window.navigator as any).msSaveOrOpenBlob
            ) {
              // for IE
              (window.navigator as any).msSaveOrOpenBlob(data, ReportName);
              this.dataLoader = false;
            } else {
              const link = document.createElement("a");
              link.href = window.URL.createObjectURL(data);
              link.download = ReportName;
              link.click();
              this.dataLoader = false;
            }
          } else {
            alert("No Records Found");
            this.dataLoader = false;
          }
        },
        function (x) {
          console.log(x);
          this.dataLoader = false;
          alert("Acknowledgement failed");
        }
      );
  }
  reset() {
    this.successfulData.selected = {};
  }
  setPage(page: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    // get pager object from service
    this.pager = this.pagerService.getPager(
      this.successfulData.shortcodes.length,
      page,
      5
    );
    // get current page of items
    this.griddata = this.successfulData.shortcodes.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    );
    this.changeDetectorRef.detectChanges();
  }
}
